module.exports = __webpack_public_path__ + "assets/images/filebgc985d70f.png";